import React, { useState } from "react"
import { graphql } from "gatsby"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import { Check, RightArrow } from "../../icons"
import Slider from "react-slick"
import StructuredText from "../custom-structured-text-renderer"

const VenueInteractive = ({ title, venues }) => {
  const [current, setCurrent] = useState(0)

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    fade: true,
    afterChange: (current, next) => {
      setCurrent(current)
    },
  }

  return (
    <section className="venue-interactive">
      <div className="venue-interactive__inner">
        <div className="venue-interactive__top">
          <div className="venue-interactive__title" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            {title && <h2>{parse(title)}</h2>}
            <ul>
              {venues?.length > 0 && venues.map((el, i) => (
                <li key={i} onMouseEnter={() => setCurrent(i)}>
                  {el.title && <Link to={el.permalink}>{parse(el.title)}</Link>}
                </li>
              ))}
            </ul>
          </div>
          <div className="venue-interactive__image" data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
            {
              venues?.length > 0 && venues.map((el, i) => (
                <div className={`venue-interactive__item ${i === current ? "active" : ""} ${i === 0 ? "active" : ""}`}
                     key={i}>
                  {el.bannerImage && <Asset asset={el.bannerImage} />}
                </div>
              ))
            }
          </div>
        </div>
        <div className="venue-interactive__bottom">
          {venues?.length > 0 && venues.map((el, i) => (
            <div key={i} className={`venue-interactive__info ${current === i ? "active" : ""}`}>
              <div className="venue-interactive__content">
                {el.richContent && <StructuredText data={el.richContent} />}
                <ul>
                  {el.stands && <li>stands <span>{el.stands}</span></li>}
                  {el.seats && <li>Seats <span>{el.seats}</span></li>}
                </ul>
              </div>

              <div className="venue-interactive__explore">
                {
                  el.topFeatures?.length > 0 &&
                  <div>
                    <h3>Notable Features</h3>
                    <ul>
                      {
                        el.topFeatures.map((feature, i) => (
                          <li key={i}><span><Check /></span> {feature.title}</li>
                        ))
                      }
                    </ul>
                  </div>
                }
                {el.permalink && <Link className="btn btn--border" to={el.permalink}>Explore</Link>}
              </div>
            </div>
          ))}
        </div>
        <div className="venue-interactive__slider">
          <Slider {...settings}>
            {venues?.length > 0 && venues.map((el, i) => (
              <div key={i} className="venue-interactive__item">
                {el.bannerImage && <Asset asset={el.bannerImage} />}
                <div className="venue-interactive__item-title">
                  <h2>Our venues</h2>
                  <span>{current + 1} / {venues.length}</span>
                </div>
                {el.title && <h3>{parse(el.title)}</h3>}
                {el.richContent && <StructuredText data={el.richContent} />}
                {el.topFeatures?.length > 0 &&
                  <div className="venue-interactive__item-feature">
                    <div>
                      <h4>Notable Features</h4>
                      <ul>
                        {
                          el.topFeatures.map((feature, i) => (
                            <li key={i}><span><Check /></span> {feature.title}</li>
                          ))
                        }
                      </ul>
                    </div>
                    <div className="venue-interactive__item-button">
                      <ul>
                        {el.seats && <li>Seats <span>{el.seats}</span></li>}
                        {el.stands && <li>stands <span>{el.stands}</span></li>}
                      </ul>
                      {el.permalink && <Link className="btn btn--border" to={el.permalink}>Explore</Link>}
                    </div>
                  </div>
                }
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  )
}

export default VenueInteractive

export const query = graphql`
fragment VenuesInteractiveProps on DatoCmsVenuesInteractive {
  ... on DatoCmsVenuesInteractive {
    id
    title
    venues {
      title
      slug
      seats
      stands
      topFeatures {
        title
      }
      permalink
      bannerImage {
        ...InternalAssetProps
      }
      richContent {
        value
      }
    }
  }
}
`